import * as yup from "yup";

export const validationSchemaPrice = yup.object().shape({
    orderTypeItemId: yup
    .string()
    .required("Wybierz typ")
});